import * as ngCore from '@angular/core'

@ngCore.Component({
  selector: 'atn-ds-divider',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {}
